import { Button, Tooltip } from "antd";
import React from "react";
import { Spin } from "antd";
import { LoadingOutlined, HomeOutlined } from "@ant-design/icons";
import { Radio, Row } from "antd";

import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import digitalFactoryLogo from "../../images/DigitalFactory.png";
import { Link, withRouter } from "react-router-dom";
import StablePrime from "../Tables/StablePrime";
import { FaMaximize, FaMinimize } from "react-icons/fa6";
import queryString from "query-string";
import { getUrlCode } from "../../utils/CustomFunc";


const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

class Pharos extends React.Component {
  state = {
    mainData: null,
    tabsLoading: true,
    dailyTrend: null,
    toggleScreenIcon: 'maximize',
    hourlyTrend: null,
    linePref: null,
    linePerSummary: null,
    mainHorBarGraphData: null,
    mainHorBarGraphConfig: null,
    mainVerBarGraph: null,
    mainVerBarGraphData: null,
    mainVerBarGraphConfig: null,
    corpMainBarGraphData: null,
    corpMainBarGraphConfig: null,
    loading: true,
    loginError: false,
    selectedTab: null,
    lid: "all",
    tabsData: null,
    selectedMnt: "all",
    table: null,
    dataLoading: false,
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }



  setSummaryData(data) {
    const newData = { ...data };
    let newDataConfig = {};
    newDataConfig["summary"] = newData["summary"];
    newDataConfig["sideHeader"] = newData["sideHeader"];
    newDataConfig["mainData"] = { ...newData };

    this._isMounted &&
      this.setState(
        {
          ...this.state,
          ...newDataConfig,
          loading: false,
          dataLoading: false,
        }
      );
  }

  onChange = (e) => {

    const st = this;
    this.setState({
      ...this.state,
      selectedTab: e.target.value,
      loading: true,
    }, () => {
      setTimeout(() => {
        this.setState({
          ...this.state,
          loading: false,
          mainData: null
        });
      }, 500);
    });
  };

  getTabs() {
    this.setState({
      ...this.state,
      tabsLoading: true
    })
    let searchParams = queryString.parse(this.props.location.search);
    liracrypt
      .get(this.props.urlEndpoint, {
        typ: this.props.match.params.typ,
        subtyp: this.props.match.params.subtyp,
        ...searchParams,
        ...this.props.urlData,
      })
      .then((response) => {
        let __tabs = response.data.config.tabData;
        this.props.setPageHeader(response.data.config.pageTitle || "Pharos XYZ");
        this.setState(
          {
            tabsData: __tabs,
            tabsLoading: false,
            selectedTab: __tabs?.find((x) => x.isDefault === true)?.subTyp,
            pageData: response.data.config.pageData,
            pageTitle: response.data.config.pageTitle || "",
            loading: false
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {

    // this.clearCache();
    // this.updateMdictVersion();
    this._isMounted = true;
    this.getTabs();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.match.params.typ !== prevProps.match.params.typ ||
      this.props.match.params.subtyp !== prevProps.match.params.subtyp ||
      this.props.location.search !== prevProps.location.search
    ) {
      // Refresh data when URL params or search params change
      this.getTabs();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }


  requestFullScreen() {
    let element = document.body;
    // Supports most browsers and their versions.
    var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;

    if (requestMethod) { // Native full screen.
      requestMethod.call(element);
    }
  }

  fullscreen(_this) {
    var isInFullScreen = (document.fullscreenElement && document.fullscreenElement !== null) ||
      (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
      (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
      (document.msFullscreenElement && document.msFullscreenElement !== null);

    var docElm = document.documentElement;
    if (!isInFullScreen) {
      _this.setState({
        ..._this.state,
        toggleScreenIcon: 'minimize'
      })
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen();
      }
    } else {
      _this.setState({
        ..._this.state,
        toggleScreenIcon: 'maximize'
      })
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  render() {
    if (this.state.tabsLoading) {
      return (
        <div className="Loading" style={{ minHeight: "100vh" }}>
          <Spin indicator={antIcon} />
        </div>
      )
    }
    if (this.state.tabsData) {
      return (
        <>
          <SessionError visible={this.state.loginError} />
          <div
            style={{
              background: "#0B0C0E",
              paddingTop: 30,
              height: '100vh'
              // backgroundImage:
              //   "radial-gradient(circle, rgba(98,46,43,1) 0%, rgba(43,36,46,1) 50%, rgba(26,29,36,1) 100%)",
            }}
          >
            <div
              style={{
                display: "inline-flex",
                alignContent: "center",
                alignItems: "center",
                justifyContent: "space-around",
                width: "100%",
              }}
            >
              <div
                className="logo"
                style={{
                  margingLeft: 14,
                  padding: 10,
                }}
              >
                <img src={digitalFactoryLogo} alt="sarex" width="80" />
              </div>
              {/* <div

                style={{
                  margingLeft: 150,
                  padding: 10,
                  color: "#bdc3c7",
                  textAlign: "center",
                  fontSize: "40px",
                  fontWeight: 600,


                }}
              >
                {this.state.pageTitle || ''}
              </div> */}
              <Radio.Group
                className="managerTabs"
                value={"small"}
                onChange={this.onChange}
              >
                {this.state.tabsData &&
                  this.state.tabsData.map((tab, index) => (
                    <Radio.Button
                      key={index}
                      className={`${tab?.label?.toLowerCase()} ${this.state.selectedTab === tab?.subTyp ? "pharos-active-tab" : ""}`}
                      style={{
                        background: "#021622",
                        padding: 10,
                        border: "2px solid #021826",
                        color: tab?.color,
                        textAlign: "center",
                        fontSize: "17px",
                        fontWeight: 600,

                        maxWidth: "200px",
                      }}
                      value={tab?.subTyp}
                    >
                      {tab?.label}
                    </Radio.Button>
                  ))}
              </Radio.Group>
              <div
                style={{
                  //   boxShadow:
                  //     "rgb(30 30 30) 5px 5px 10px, rgb(46 46 46) -5px -5px 10px",
                  borderRadius: 10,
                  padding: 10,
                  marginRight: 25,
                  marginBottom: 13,

                  background: "#021622",
                  //   backgroundImage:
                  //     "linear-gradient(145deg, rgba(106,106,111,1) 0%, rgba(42,42,52,0.8748541652989321) 57%, rgba(33,32,40,1) 100%)",
                  border: "2px solid #021826",
                }}
              >
                <Link to={`/v02/${getUrlCode()}/dashboard`}>
                  <HomeOutlined
                    style={{
                      fontSize: 25,
                    }}
                  />
                </Link>
              </div>
              <Tooltip title={() => this.capitalizeFirstLetter(this.state.toggleScreenIcon)} color="blue">
                <div
                  style={{
                    borderRadius: 10,
                    padding: 10,
                    marginRight: 25,
                    marginBottom: 13,

                    background: "#021622",
                    border: "2px solid #021826",
                  }}
                >
                  <Button
                    type="link"
                    icon={
                      this.state.toggleScreenIcon === 'maximize' ? <FaMaximize /> :
                        <FaMinimize />
                    }
                    onClick={() => this.fullscreen(this)}>
                    {''}
                  </Button>
                </div>
              </Tooltip>
            </div>
            {this.state.loading === false ? (
              <div>
                <div
                  className="main-container"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <>
                      {this.state.mainData ? (
                        <div
                          style={{
                            backgroundImage: "linear-gradient(to bottom right, #010b11, #021b2a )",
                            border: "2px solid #021826",
                            borderRadius: "10px",
                            margin: "10px",
                            padding: "0px 10px 30px 0px ",
                          }}
                        >
                          <Row>

                            <div
                              style={this.state.sideHeader.block.txt.style}
                            >
                              {this.state.sideHeader.block.txt.text}
                            </div>

                          </Row>
                        </div>
                      ) : null}
                    </>
                    {this.state.mainData ? (
                      <div
                        style={{
                          margin: "10px",
                          padding: "10px",
                          borderRadius: "10px",
                          background: "#011019",
                          border: "2px solid #021826",
                        }}
                      >
                        <Row>
                          <div>
                            {
                              this.state.summary.map((summaryMap, index) => (
                                <div
                                  key={index}
                                  style={{
                                    display: "inline-flex",
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: "5px 5px 5px 5px",
                                    width: "100%",
                                    margin: "10px 0px 10px 0px",
                                    backgroundImage: "linear-gradient(to bottom right, #010b11, #021b2a )",
                                    border: "2px solid #021826",
                                    borderRadius: "7px",
                                  }}
                                >

                                  <span
                                    style={{
                                      display: "inline-block",
                                      verticalAlign: "top",
                                    }}
                                  >
                                    <img
                                      src={require(`../../assets/static/${summaryMap.icon}`)}
                                      alt={summaryMap.icon}
                                      height="50px"
                                      width="50px"
                                    />
                                  </span>
                                  <span
                                    style={{

                                      display: "inline-block",
                                      verticalAlign: "center",
                                    }}
                                  >
                                    <div style={summaryMap.txt1.style}>
                                      {summaryMap.txt1.text}
                                    </div>
                                  </span>
                                  <span
                                    style={{

                                      display: "inline-block",
                                      verticalAlign: "center",
                                    }}
                                  >
                                    <div style={summaryMap.txt2.style}>
                                      {summaryMap.txt2.text}
                                    </div>
                                  </span>
                                </div>
                              ))}
                          </div>
                        </Row>
                      </div>
                    ) : null}
                  </div>
                  <div style={{ width: "100%" }}>
                    <StablePrime
                      setSummary={(data) => this.setSummaryData(data)}
                      widthClass="auto"
                      autoUpdate={false}
                      editSingleColumn={true}
                      zenTable={true}
                      url={this.state.pageData.api}
                      data={
                        this.props.urlData ? { ...this.props.urlData, selectedTab: this.state.selectedTab } : {
                          ...queryString.parse(this.props.location.search),
                          ...this.state.pageData.params,
                          selectedTab: this.state.selectedTab,
                          typ: this.props.match.params.typ,
                          subtyp: this.props.match.params.subtyp,
                        }
                      }
                      identity="DataTable"
                    />
                    {/* <StablePrime url="lineperformance" data={this.props.urlData || {}} identity="perfparam" /> */}
                  </div>
                </div>
              </div>
            ) : (
              <div className="Loading" style={{ minHeight: "100vh" }}>
                <Spin indicator={antIcon} />
              </div>
            )}
          </div>
        </>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}

export default withRouter(Pharos);
